module.exports = __webpack_public_path__ + "00078a3628d0641575cd2a80c1581a3d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PA.svg
// module id = eGP/
// module chunks = 0